import { render, staticRenderFns } from "./redirectUrl.vue?vue&type=template&id=6346b215&scoped=true&"
import script from "./redirectUrl.vue?vue&type=script&lang=js&"
export * from "./redirectUrl.vue?vue&type=script&lang=js&"
import style0 from "./redirectUrl.vue?vue&type=style&index=0&id=6346b215&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6346b215",
  null
  
)

export default component.exports